module.exports = __webpack_public_path__ + "img/icon-tjjl.fce590ed.png";